import type { CaseFormValues } from "@/components/Forms/CaseForm.tsx";
import { useFetchTeams } from "@/queries/useFetchTeam.ts";
import { CircularProgress, MenuItem, Paper, Typography } from "@mui/material";
import { RhfTextField } from "mui-rhf-integration";
import type { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<CaseFormValues>;
    name: keyof CaseFormValues;
    label: string;
    disabled?: boolean;
};

const CaseFormTeamsSelect = ({ form, name, label, disabled = false }: Props) => {
    const { data, isError, isRefetching, isLoading, error } = useFetchTeams();

    if (isError) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <Typography variant={"h5"}>Error loading teams</Typography>
                <Typography variant={"body1"}>{error.message}</Typography>
            </Paper>
        );
    }

    if (isLoading || isRefetching) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <CircularProgress size={"12px"} />
            </Paper>
        );
    }

    return (
        <RhfTextField
            select
            control={form.control}
            name={name}
            label={label}
            disabled={disabled}
            sx={{
                width: "100%",
                backgroundColor: "#fff",
            }}
        >
            {data?.map((team) => (
                <MenuItem key={`${name}-${team.id}`} value={`${team.teamName}`}>
                    {team.teamName}
                </MenuItem>
            ))}
        </RhfTextField>
    );
};

export default CaseFormTeamsSelect;
